const initQuestionnaire = () => {
  const root = document.querySelector('[data-questionnaire]');
  if (!root) return;

  const body = root.querySelector('[data-questionnaire-body]');
  const list = root.querySelector('[data-questionnaire-list]');
  const items = Array.from(root.querySelectorAll('[data-step]'));
  const final = root.querySelector('[data-questionnaire-final]');
  const counters = Array.from(root.querySelectorAll('[data-counter]'));

  const transitionDuration = 300;
  const finalStep = items.length;

  if (!body || !list || !items.length || !final) return;

  let currentStep = items.findIndex((item) =>
    item.classList.contains('is-active')
  );

  let isAnimating = false;

  if (currentStep < 0) {
    currentStep = 0;
    items[currentStep].classList.add('is-active');
  }

  // =========================
  // CACHE VALIDITY (важно)
  // =========================
  const stepState = new Map();

  const updateCounters = (index) => {
    counters.forEach((c) => {
      c.textContent = `${index + 1}/${items.length}`;
    });
  };

  const updateQuestionHeight = (item) => {
    if (!item) return;
    list.style.height = `${item.offsetHeight}px`;
  };

  const updateBodyHeight = (el) => {
    if (!el) return;
    body.style.height = `${el.offsetHeight}px`;
  };

  // =========================
  // VALIDATION CORE
  // =========================
  const isStepValid = (step) => {
    if (step.dataset.optional !== undefined) return true;

    const files = step.querySelectorAll('[data-attachment-files]');

    for (const c of files) {
      if (c.children.length > 0) return true;
    }

    const checked = step.querySelectorAll(
      'input[type="checkbox"]:checked, input[type="radio"]:checked'
    );

    if (checked.length) return true;

    const textInputs = step.querySelectorAll(
      'input[type="text"], input[type="number"], input[type="email"], input[type="tel"], textarea'
    );

    for (const i of textInputs) {
      if (i.value.trim()) return true;
    }

    const selects = step.querySelectorAll('select');

    for (const s of selects) {
      if (s.value) return true;
    }

    return false;
  };

  // =========================
  // BUTTON STATE (with cache)
  // =========================
  const updateNextButtonState = () => {
    if (currentStep === finalStep) return;

    const step = items[currentStep];
    if (!step) return;

    const btn = step.querySelector('[data-btn-next]');
    if (!btn) return;

    let cached = stepState.get(step);

    const valid = isStepValid(step);

    // кеш чтобы не дёргать DOM лишний раз
    if (cached === valid) return;

    stepState.set(step, valid);

    btn.disabled = !valid;
  };

  // =========================
  // GLOBAL UPDATE TRIGGER
  // =========================
  const triggerUpdate = () => {
    updateNextButtonState();
  };

  root.addEventListener('questionnaire:update', triggerUpdate);

  // =========================
  // NAVIGATION
  // =========================
  const showStep = (index) => {
    if (
      index === currentStep ||
      index < 0 ||
      index > finalStep ||
      isAnimating
    )
      return;

    const isFinal = index === finalStep;
    const isCurrentFinal = currentStep === finalStep;

    const current = isCurrentFinal ? final : items[currentStep];
    const next = isFinal ? final : items[index];

    if (!current || !next) return;

    isAnimating = true;

    updateQuestionHeight(current);
    updateBodyHeight(current);

    requestAnimationFrame(() => {
      next.classList.add('is-active');
      current.classList.remove('is-active');

      list.classList.toggle('is-hidden', isFinal);

      if (!isFinal) {
        updateQuestionHeight(next);
        updateCounters(index);
      }

      updateBodyHeight(next);
      triggerUpdate();
    });

    setTimeout(() => {
      isAnimating = false;
    }, transitionDuration);

    currentStep = index;
  };

  // =========================
  // EVENTS
  // =========================
  const nav = (e, d) => {
    e.preventDefault();
    showStep(currentStep + d);
  };

  root.querySelectorAll('[data-btn-next]').forEach((b) => {
    b.addEventListener('click', (e) => nav(e, 1));
  });

  root.querySelectorAll('[data-btn-prev]').forEach((b) => {
    b.addEventListener('click', (e) => nav(e, -1));
  });

  root.querySelectorAll('[data-btn-skip]').forEach((b) => {
    b.addEventListener('click', (e) => nav(e, 1));
  });

  // INPUT / CHANGE
  root.addEventListener('input', triggerUpdate);
  root.addEventListener('change', triggerUpdate);

  // ENTER
  root.addEventListener('keydown', (e) => {
    if (e.key !== 'Enter') return;

    const step = items[currentStep];
    if (!step) return;

    const btn = step.querySelector('[data-btn-next]');
    if (btn && !btn.disabled) btn.click();
  });

  // =========================
  // ATTACHMENTS HOOK (ВАЖНО)
  // =========================
  root.addEventListener('attachment:change', triggerUpdate);
  root.addEventListener('attachment:add', triggerUpdate);
  root.addEventListener('attachment:remove', triggerUpdate);

  // =========================
  // RESIZE
  // =========================
  const ro = new ResizeObserver(() => {
    if (isAnimating) return;

    const active = currentStep === finalStep ? final : items[currentStep];

    if (!active) return;

    if (currentStep !== finalStep) {
      updateQuestionHeight(active);
    }

    updateBodyHeight(active);
  });

  items.forEach((i) => ro.observe(i));
  ro.observe(final);

  // =========================
  // INIT
  // =========================
  const initSteps = () => {
    items.forEach((item, i) => {
      item.classList.toggle('is-active', i === currentStep);
    });

    final.classList.remove('is-active');
    list.classList.remove('is-hidden');

    const active = items[currentStep];

    if (active) {
      updateQuestionHeight(active);
      updateBodyHeight(active);
    }

    updateCounters(currentStep);
    triggerUpdate();
  };

  initSteps();
};

export { initQuestionnaire };